"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatLoader = exports.EmptyStat = exports.OverviewContent = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var overviewSlice_1 = require("../../state/overviewSlice");
var SummaryCardGroup_1 = __importDefault(require("../SummaryCardGroup"));
var Graph_1 = require("../Graph");
var ManualCardGroup_1 = __importDefault(require("../ManualCardGroup"));
var EmptyStatistics_1 = __importDefault(require("../EmptyStatistics"));
function OverviewContent() {
    var errorLoadingStats = (0, react_redux_1.useSelector)(overviewSlice_1.errorOverviewSelector);
    var showStatistics = (0, react_redux_1.useSelector)(overviewSlice_1.showStatisticsOverviewSelector);
    // this className is not defined in css files
    return (react_1.default.createElement(react_1.default.Fragment, null, !errorLoadingStats && showStatistics && (react_1.default.createElement("div", { className: "overview" },
        react_1.default.createElement(SummaryCardGroup_1.default, null),
        react_1.default.createElement(Graph_1.GraphContainer, null),
        react_1.default.createElement(ManualCardGroup_1.default, null)))));
}
exports.OverviewContent = OverviewContent;
function EmptyStat(_a) {
    var angularJsDependencies = _a.angularJsDependencies;
    var errorLoadingStats = (0, react_redux_1.useSelector)(overviewSlice_1.errorOverviewSelector);
    var showStatistics = (0, react_redux_1.useSelector)(overviewSlice_1.showStatisticsOverviewSelector);
    var loadingStats = (0, react_redux_1.useSelector)(overviewSlice_1.loadingOverviewSelector);
    return (react_1.default.createElement(react_1.default.Fragment, null, !loadingStats && !errorLoadingStats && !showStatistics && react_1.default.createElement(EmptyStatistics_1.default, { angularJsDependencies: angularJsDependencies })));
}
exports.EmptyStat = EmptyStat;
function StatLoader() {
    var loadingStats = (0, react_redux_1.useSelector)(overviewSlice_1.loadingOverviewSelector);
    return (react_1.default.createElement(react_1.default.Fragment, null, loadingStats && (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "loading-tracker" },
            react_1.default.createElement("div", { className: "page-loading-icon" }))))));
}
exports.StatLoader = StatLoader;
